import * as z from "zod/v4";

const GetSourcesInput_ = z.object({
  limit: z.number().int().positive().optional(),
  offset: z.number().int().min(0).optional(),
  promptId: z.string().optional(),
});

const SourceItem_ = z.object({
  id: z.string(),
  source: z.string(),
  type: z.enum(["Owned", "Earned"]),
  domain: z.string(),
});

export const getSources = {
  name: "getSources" as const,
  input: GetSourcesInput_,
  output: z.object({ sources: z.array(SourceItem_), totalCount: z.number() }),
};
